import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const deleteRoleAssignment = async (id, { forApproval = false } = {}) => {
  try {
    const path = forApproval
      ? '/systemInvoiceRoleManagement/delete'
      : '/systemInvoiceRoleManagement/delete-direct';
    const response = await apiClient.delete(path, {
      data: { id },
    });
    const successMessage = response?.data?.message || 'Role assignment deleted successfully';
    notify('success', successMessage);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      'Failed to delete role assignment';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
